import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../Utils/Axios';

const AdminUserDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/admin/users/${id}`);
      setUser(res.data.user || null);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to load user detail');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const deleteUser = async () => {
    const ok = window.confirm('Delete this user account?');
    if (!ok) return;

    try {
      await api.delete(`/api/admin/users/${id}`);
      toast.success('User deleted');
      navigate('/admin-users');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to delete user');
    }
  };

  if (loading) return <div className="col-lg-12">Loading user detail...</div>;
  if (!user) return <div className="col-lg-12">User not found.</div>;

  return (
    <div className="col-lg-12">
      <div className="dashboard-inner">
        <div className="author-and-action-btn-area two mb-40">
          <div className="author-area two">
            <div className="author-img">
              <img src={user.avatar || 'https://api.dicebear.com/9.x/personas/svg?seed=User'} alt="" />
            </div>
            <div className="author-content">
              <span>User Detail</span>
              <h4>{`${user.firstName || ''} ${user.lastName || ''}`.trim()}</h4>
              <p>{user.email}</p>
            </div>
          </div>
          <div className="action-btn-group">
            <button className="primry-btn-1" onClick={deleteUser}>Delete User</button>
          </div>
        </div>

        <div className="row g-4 mb-40">
          <div className="col-lg-4 col-md-6">
            <div className="counter-single">
              <div className="coundown">
                <p>Email Verified</p>
                <h3>{user.isEmailVerified ? 'Yes' : 'No'}</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="counter-single two">
              <div className="coundown">
                <p>Applied Jobs</p>
                <h3>{(user.appliedJobs || []).length}</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="counter-single three">
              <div className="coundown">
                <p>Bookmarked Jobs</p>
                <h3>{(user.bookmarkedJobs || []).length}</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="table-wrapper2">
          <div className="title-and-btn">
            <div className="title">
              <h4>Profile Information</h4>
            </div>
          </div>
          <table className="eg-table table job-list-table mb-0">
            <tbody>
              <tr><td>Phone</td><td>{user.phoneNumber || '-'}</td></tr>
              <tr><td>Location</td><td>{user.currentLocation || '-'}</td></tr>
              <tr><td>Qualification</td><td>{user.qualification || '-'}</td></tr>
              <tr><td>Designation</td><td>{user.designation || '-'}</td></tr>
              <tr><td>Joined</td><td>{new Date(user.createdAt).toLocaleDateString()}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminUserDetail;